import styled from '@emotion/styled';
import tw from 'twin.macro';
import { Button } from 'antd';

const CustomDropdownButton = styled(Button)`
    ${tw`border border-purpleFont text-headerColor rounded text-[13px]`}
    box-shadow: none !important;
    height: 100% !important;
    display: flex;
    align-items: center;
    &:hover:not(:disabled) {
        ${tw`border-purpleFont text-headerColor opacity-80`}
    }
    &:focus:not(:disabled) {
        ${tw`border-purpleFont text-headerColor opacity-80`}
    }
`;

export default CustomDropdownButton;
